import * as React from 'react'

/**
 * @description AppGallery icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { AppGallery } from '@sravni/design-system-icons'
 *
 * <AppGallery />
 * ```
 */
export const AppGallery = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="AppGallery" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.736 6.836c0-3.697 1.353-5.05 5.05-5.05h7.9c3.698 0 5.05 1.353 5.05 5.05v7.901c0 3.697-1.355 5.05-5.053 5.05H6.787c-3.698 0-5.05-1.353-5.05-5.05v-7.9Zm5.55-2.5H8.61v.45a2.13 2.13 0 0 0 2.126 2.127 2.13 2.13 0 0 0 2.127-2.126v-.45h1.323v.45a3.453 3.453 0 0 1-3.45 3.45 3.453 3.453 0 0 1-3.45-3.45v-.45Z"
      fill="currentColor"
    />
  </svg>
))
